import React from 'react';
import { CatalogueLayout } from 'containers';
import { useCataloguePage } from './hooks';

export const CataloguePage = () => {
	useCataloguePage();

	return <CatalogueLayout />;
};
